<template>
    <div v-if="isDispatcher || isAdmin || isMainCommercial || isCommercialDispatcher">
        <div>
            <card :id="id" :exportXlsx="true" :history="true" :title="'Solicitud de Muestra N° ' + id"
                bg="bg-dark text-white" icon="glass-martini" @exportRequest="exportRequest(id)" @showHistory="showHistory(id)">
                <template v-slot:titleBadge>
                    <management-countdown-badge :deadline="req.dispatchManagementDeadline" :sample-state="req.sampleState" />
                </template>
                <alert v-if="!req.requiredDispatch" :message="req.cantDispatchReason ? req.cantDispatchReason: ''" />
                <card v-if="req.requiredDispatch" class="card cardShadow-light" title="Datos Principales">
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                            <th style="width: 20%">Unidad de Negocio:</th>
                            <td style="width: 30%">{{ req.businessUnitName }}</td>
                            <th style="width: 20%">Centro de Costo:</th>
                            <td style="width: 30%">{{ req.costCenterName }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Despacho Progresivo:</th>
                            <td style="width: 30%">{{ req.progressDispatch }}</td>
                            <th style="width: 20%">Objetivo de la Muestra:</th>
                            <td style="width: 30%">{{ req.sampleTargetName }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Detalles de objetivo:</th>
                            <td style="width: 30%">{{ req.sampleReasonName }}</td>
                            <th style="width: 20%">Fecha de Envío:</th>
                            <td style="width: 30%">{{ req.sendedAtString }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Fecha Requerida Despacho:</th>
                            <td style="width: 30%">{{ req.requiredDispatchDateString }}</td>
                            <th style="width: 20%">Fecha/Hora Límite de Gestión:</th>
                            <td style="width: 30%">
                                <span v-if="req.dispatchManagementDeadlineString">{{ req.dispatchManagementDeadlineString }}</span>
                                <span v-else-if="req.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
                                <span v-else class="text-muted">Sin Registro</span>
                            </td>
                        </tr>
                        </table>
                    </div>
                </card>
                <card v-if="req.requiredDispatch" class="card mt-2 cardShadow-light" title="Datos de despacho">
                    <div class="card border-secondary">
                        <div v-if="existDispatch" class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Nombre de Empresa/Cliente:</th>
                                    <td>{{ dispatch.enterpriseName }}</td>
                                    <th>País</th>
                                    <td>{{ dispatch.country.name }}</td>
                                    <th>Ciudad:</th>
                                    <td>{{ dispatch.city.name }}</td>
                                </tr>
                                <tr>
                                    <th>Código Postal</th>
                                    <td>{{ dispatch.postalCode }}</td>
                                    <th>Dirección:</th>
                                    <td>{{ dispatch.address }}</td>
                                    <th>Segunda Dirección:</th>
                                    <td>{{ dispatch.secondAddress }}</td>
                                </tr>
                                <tr>
                                    <th>Teléfono:</th>
                                    <td>{{ dispatch.phoneNumber }}</td>
                                    <th>Email:</th>
                                    <td>{{ dispatch.email }}</td>
                                    <th>Contacto (Sr./Sra.):</th>
                                    <td>{{ dispatch.contactName }}</td>
                                </tr>
                                <tr>
                                    <th>Observaciones:</th>
                                    <td>{{ dispatch.remarks }}</td>
                                </tr>
                            </table>
                        </div>
                        <alert v-else message="Aún no se registra Despacho" />
                    </div>
                </card>
            </card>
        </div>
        <modal id="showHistory" :lg="true" title="Historial de solicitud">
            <history-modal-request :historyOptions="historyOptions"></history-modal-request>
        </modal>
        <dispatch-approve v-if="req.requiredDispatch" @updateObservations="updateObservations" :id="id" :details="details" :component="component" :request="req"></dispatch-approve>
    </div>
</template>

<script>
import { Get } from "../../../helper/axios.js";
import Card from "../../../components/Card.vue";
import DispatchApprove from "./dispatchApprove.vue";
import HistoryModalRequest from "@/views/requests/history/HistoryModalRequest.vue";
import $ from "jquery";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
    components: {
        HistoryModalRequest,
        Card,
        DispatchApprove,
    },
    data() {
        return {
            historyOptions: {
				id: null,
				history: [],
			},
            id: this.$route.params.id,
            apiUrl: this.$store.getters.apiUrl,
            isAdmin: this.$store.getters.isAdmin,
            isDispatcher: this.$store.getters.isDispatcher,
            isCommercial: this.$store.getters.isCommercial,
            isCourier: this.$store.getters.isCourier,
            isMainCommercial: this.$store.getters.isMainCommercial,
            isCommercialDispatcher: this.$store.getters.isCommercialDispatcher,
            isOenology: this.$store.getters.isOenology,
            Get,
            req: {},
            existDispatch: false,
            details: [],
            component: [],
            minDate: "",
        };
    },
    created() {
        if (this.id) {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/" + this.id, (res) => {
                this.req = res.data;
                var createdAtRequest = new Date(
                    res.data.createdAt.split("-").reverse().join("-")
                );
                var dd = String(createdAtRequest.getDate() + 1).padStart(2, "0");
                var mm = String(createdAtRequest.getMonth() + 1).padStart(2, "0");
                var yyyy = createdAtRequest.getFullYear();
                this.minDate = yyyy + "-" + mm + "-" + dd;
                this.$store.commit("setLoading", false);
            });
            this.$store.commit("setLoading", true);
            this.Get(
                this.apiUrl + "v1/dispatchs?sampleId=" + this.id,
                (res) => {
                    this.dispatch = res.data;
                    this.existDispatch = true;
                    this.$store.commit("setLoading", false);
                },
                () => {
                    this.existDispatch = false;
                }
            );
        }
        this.getDetails();
        this.getComponent();
    },
    methods: {
        updateObservations(){
            this.getDetails();
        },
        getDetails() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/requestsample/${this.id}/details`, (res) => {
                this.details = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getComponent() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/selectedComponents/bySampleId/${this.id}`, (res) => {
                this.component = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        showHistory() {
			this.historyOptions.history = this.req.histories;
			$("#showHistory").modal("show");
		},
        exportRequest(id) {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/exportRequestSample/" + id, (res) => {
                var array = base64ToArrayBuffer(res.data);
                var a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(
                    new Blob([array], {
                        type: "application/octet-stream",
                    })
                );
                a.download = "FCOM " + id + ".xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.$store.commit("setLoading", false);
            });
        },
    },
};
</script>
